import * as React from "react";
import classNames from "clsx";
import { Slot } from "@radix-ui/react-slot";

type GridElement = React.ElementRef<"div">;
type GridProps = React.ComponentPropsWithoutRef<"div"> & {
  asChild?: boolean;
};

const Grid = React.forwardRef<GridElement, GridProps>((props, forwardedRef) => {
  const {
    className,
    asChild,
    style: propStyle,
    ...gridProps
  } = props;
  const Comp = asChild ? Slot : "div";

  let style: React.CSSProperties | Record<string, string | undefined> = {
    ...propStyle,
  };

  return (
    <Comp
      {...gridProps}
      ref={forwardedRef}
      className={classNames("in-grid", className)}
      style={Object.keys(style).length ? style : undefined}
    />
  );
});

Grid.displayName = "Grid";

export { Grid };
export type { GridProps };
